import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AvailableProvidersSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AvailableProvidersSettingsQuery = { __typename?: 'Query', DefaultItineraryProviders: Array<{ __typename?: 'ProviderInfo', providerName?: string | null, providerDescription: string }>, CourierDesignItineraryProviders: Array<{ __typename?: 'ProviderInfo', providerName?: string | null, providerDescription: string }> };


export const AvailableProvidersSettingsDocument = gql`
    query AvailableProvidersSettings {
  DefaultItineraryProviders {
    providerName
    providerDescription
  }
  CourierDesignItineraryProviders {
    providerName
    providerDescription
  }
}
    `;

/**
 * __useAvailableProvidersSettingsQuery__
 *
 * To run a query within a React component, call `useAvailableProvidersSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableProvidersSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableProvidersSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableProvidersSettingsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableProvidersSettingsQuery, AvailableProvidersSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableProvidersSettingsQuery, AvailableProvidersSettingsQueryVariables>(AvailableProvidersSettingsDocument, options);
      }
export function useAvailableProvidersSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableProvidersSettingsQuery, AvailableProvidersSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableProvidersSettingsQuery, AvailableProvidersSettingsQueryVariables>(AvailableProvidersSettingsDocument, options);
        }
export type AvailableProvidersSettingsQueryHookResult = ReturnType<typeof useAvailableProvidersSettingsQuery>;
export type AvailableProvidersSettingsLazyQueryHookResult = ReturnType<typeof useAvailableProvidersSettingsLazyQuery>;
export type AvailableProvidersSettingsQueryResult = Apollo.QueryResult<AvailableProvidersSettingsQuery, AvailableProvidersSettingsQueryVariables>;